import React, { useState } from 'react';
import AButton from '../../../../../views/pages/manage/common/form-fields-mui/AButton';
import BankDetailsCard from '../../../../../views/pages/manage/edpOps/studentDetails/paymentSummary/studentBankDetails/BankDetailsCard';
import AddEditBankAccountDialog from '../../../../../views/pages/manage/edpOps/studentDetails/paymentSummary/studentBankDetails/AddEditBankAccountDialog';
import { bankAccountTypes, studentRelationDropdown, userTypes } from '../../../../../views/pages/manage/edpOps/studentDetails/paymentSummary/studentBankDetails/utils';
import { formattedPrice } from '../../../../../views/pages/manage/unAssigned/collectPayment/utils';
import styles from "../styles.module.scss";
import VendorAccountDetailsDialog from './VendorAccountDetailsDialog';
import ChequeDetailsCard from './chequeDetails/ChequeDetailsCard';

const RefundAccountsCard = ({
    accountDetails,
    multiTypeRefundUtils = {},
    title,
    viewOnly,
    manageAccountsClickHandler = () => { },
    openDetailsDialogIcon,
    showBeneficiaryTypeChip,
    amount,
    primaryStudentAccount,
    setChequeDetailsForm
}) => {


    const [dialogInfo, setDialogInfo] = useState({});


    const { allBanks, allCountries } = multiTypeRefundUtils;
    const viewAccountDetails = (details) => {

        const { bankMasterId, country, accountType, bankAccountType, accountRelation, beneficiaryType } = details;

        setDialogInfo({
            isOpen: beneficiaryType === "Student", // for student account details
            vendorAccountDetailsDialogOpen : beneficiaryType === "Third Party", //for vendor account details
            viewOnly: true,
            initialForm: {
                ...details,
                bank: allBanks?.find(bank => bank?.value == bankMasterId),
                country: allCountries?.find(el => el?.value === country),
                accountType: userTypes?.find(type => type?.value === accountType),
                bankAccountType: bankAccountTypes?.find(type => type?.value === bankAccountType),
                studentRelation: studentRelationDropdown?.find(rel => rel?.value === accountRelation)
            }
        })
    }


    return (
        <div className='a-card m-0'>
            <div className='d-flex justify-content-between'>
                <div className={styles['accordion-title']}>
                    <span className='mr-1'>{title}</span>
                    •
                    {amount != null && <span className={styles['amount'] + " ml-1"}>{formattedPrice(amount)}</span>}
                </div>
                {
                    !viewOnly &&
                    <AButton
                        variant='outline'
                        size='xs'
                        onClick={manageAccountsClickHandler}
                    >
                        Manage Accounts
                    </AButton>
                }
            </div>

            <div className='d-flex flex-start flex-wrap' style={{ gap: '0.5rem' }}>
                {accountDetails?.map(details => {

                    const isPrimaryAccount = details == primaryStudentAccount;

                    return (
                        details?.paymentModeType === 'CHKL'
                            ?
                            <ChequeDetailsCard
                                chequeDetailsForm={details}
                                setChequeDetailsForm={setChequeDetailsForm}
                                viewOnly={viewOnly}
                                bankDropdown={allBanks}
                                highlightCardBorder={!viewOnly && isPrimaryAccount} //border highlighted for the primary refund account
                            />
                            : <BankDetailsCard
                                key={details?.id}
                                accountDetails={details}
                                iconClickHandler={() => viewAccountDetails(details)}
                                openDetailsDialogIcon={openDetailsDialogIcon}
                                showBeneficiaryTypeChip={showBeneficiaryTypeChip}
                                highlightCardBorder={!viewOnly && isPrimaryAccount}
                            />
                    )
                })}

            </div>

            <AddEditBankAccountDialog
                dialogInfo={dialogInfo}
                setDialogInfo={setDialogInfo}
                key={dialogInfo?.initialForm?.id}
                dropdownData={multiTypeRefundUtils}
            />

            <VendorAccountDetailsDialog
                dialogInfo={dialogInfo}
                setDialogInfo={setDialogInfo}
                // key={dialogInfo?.initialForm?.id}
                dropdownData={multiTypeRefundUtils}
            />




        </div>
    );
}

export default RefundAccountsCard;